var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-counter-rounded"},[_vm._v("\n  "+_vm._s(_vm.count)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }